export const REQUEST_STATUSES = {
    pending: {
        name: 'Pending',
        id: 1,
        color: 'text-orange-50',
        bg: 'bg-yellow-100 dark:bg-yellow-600/75',
    },
    rejected: {
        name: 'Rejected',
        id: 2,
        color: 'text-red',
        bg: 'bg-red/15 dark:bg-red-810/26',
    },
    approved: {
        name: 'Approved',
        id: 3,
        color: 'text-purple-140',
        bg: 'bg-purple/15 dark:bg-purple-720',
    },
    connected: {
        name: 'Connected',
        id: 4,
        color: 'text-green-200',
        bg: 'bg-green-80 dark:bg-green-850',
    },
}
